module.exports = __webpack_public_path__ + "static/support-147fb63057db93fedfff50c94dc77a3d.jpg";